import {NewsDetailContent} from '@/src/features/news-articles'
import {PageData} from '@/src/core/domain/entities/page/page-data'
import {NewsDetailContentContainer} from './screen.detail.content'
import React, {Suspense} from 'react'
import {LoadingContentPage} from '@/src/shared/ui/layout/ui/loading-content-page'

export const NewsDetailScreen = (
  props: PageData<NewsDetailContent> & {suspense: {content: React.ReactNode}},
) => {
  return <NewsDetailContentContainer {...props} suspense={props.suspense} />
}

export const NewsDetailPageContent = ({promise}: {promise: Promise<any>}) => {
  return (
    <Suspense fallback={<LoadingContentPage />}>
      <ServerRenderContent promise={promise} />
    </Suspense>
  )
}

const ServerRenderContent = async ({promise}: {promise: Promise<any>}) => {
  const {html: nodes} = await promise

  return nodes
}
